export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {Notification} from 'kpc';

export default class extends Component {
    static template = template;

    static defaults() {
        return {
            types: ['info', 'error', 'warning', 'success'] as const
        }
    }

    showNotification(type: 'info' | 'error' | 'warning' | 'success') {
        Notification[type]({
            title: type,
            content: `这是一条${type}类型的通知`
        });
    }
}